import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { AllocationSheetsServiceProxy, AllocationSheetStatus } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from '@node_modules/ngx-bootstrap/modal';
import { HistoryStatusModalComponent } from '@app/components/common/sheet-status/history-status-modal/history-status-modal.component';
import { Moment } from 'moment';

export interface IStatusData {
  status: number;
  date?: string;
  reason?: string;
}

@Component({
  selector: 'app-sheet-status',
  templateUrl: './sheet-status.component.html',
  styleUrls: ['./sheet-status.less'],
})
export class SheetStatusComponent extends AppComponentBase implements OnInit {
  @Input() standaloneMode: boolean = false;
  @Input() showReason: boolean;
  @Input() allocationSheetId: string;
  @Input() reason?: string;
  newStatus:AllocationSheetStatus
  statusChangedDate:Moment
  whoChanged:string
  @ViewChild('historyStatusModal', { static: true })
  modal: HistoryStatusModalComponent;

  constructor(injector: Injector, private _allocationSheetService:AllocationSheetsServiceProxy) {
    super(injector);
  }

  ngOnInit(): void {
    this.getLastStatusChangedOwner()
    abp.event.on('app.evt.statusChanged', () => {
        this.getLastStatusChangedOwner()
    });
  }

  showHistoryModal() {
    this.modal.modal.show();
  }

  getLastStatusChangedOwner(){
    if(this.allocationSheetId){
      this._allocationSheetService.getAllocationSheetStatusHistory(this.allocationSheetId)
      .subscribe(x=>{
        if(x.items.length>0){
          let lastStatusChange = x.items[0]
          this.statusChangedDate = lastStatusChange.statusChange
          this.newStatus = lastStatusChange.newStatus
          this.whoChanged = `${lastStatusChange.whoChange.firstName} ${lastStatusChange.whoChange.lastName}`
        }
       
      })
    }
   
  }
}
